export const gsColors = {
  black: '#000000',
  ebb: '#E9E2E1',
  facebook: '#3b5998',
  grape: '#52215B',
  hintOfRed: '#F7F5F5',
  honeyFlower: '#631E71',
  darkEggplant: '#37173d',
  mineShaft: '#3f3f3f',
  paleSlate: '#c2b9bf',
  persianGreen: '#00B497',
  prim: '#F4EBF2',
  provincialPink: '#fef7f2',
  saltBox: '#746D76',
  seance: '#822297',
  sunsetOrange: '#07218F',
  tangerineHover: '#2C42A0',
  venus: '#9c969a',
  white: '#FFFFFF',
  coral: '#faf9f9',
  cobalt: '#07218F',
  errorRed: '#F75D51',
  salmon: '#F7CBC5',
  backgroundSalmon: '#f1cbc4',
  tangerine: '#F75D51',
  progressBar: '#8290CD',
  primaryHover: '#0728B4',
  pinkHover: '#F9D2CD',
  khaki: '#F9F4EE',
  meredithGrey: '#878787',
  mediumGrey: '#747474',
  greyPoupon: '#BEBFC0',
  textGrey: '#C7C7C7',
  lightTangerine: '#E8E2E1',
  greyBelowHero: '#E8E2E180',
  darkGrey: '#545454',
  eggshell: '#F9F6F1',
  sand: '#E7DDCE',
  dividerGrey: '#C8C8CC',
};
